import {
  BrandedSearchRateByCampaignAdvancedSearchResponse,
  BrandedSearchRateByCampaignData
} from 'src/components/Layout/Advertising/ConnectPageLayout/visualizations/AudiencesTab/BrandedSearchRateByCampaign/types';
import _get from 'lodash/get';

/**
 * Parses advanced search response from Time to Conversion api request
 */
export const brandedSearchRateByCampaignAdvancedSearchParser = (
  response: BrandedSearchRateByCampaignAdvancedSearchResponse
) => {
  const brandedSearchRateByCampaignData: BrandedSearchRateByCampaignData[] = _get(
    response,
    ['aggregations', 'by_campaign.keyword'],
    []
  );
  return brandedSearchRateByCampaignData;
};

interface BuildRequestForBrandedSearchRateByCampaignParameters {
  startDayId: string | number;
  endDayId: string | number;
  retailerId?: string | number;
}

export const buildRequestForBrandedSearchRateByCampaign = ({
  startDayId,
  endDayId,
  retailerId = 1
}: BuildRequestForBrandedSearchRateByCampaignParameters) => {
  return [
    {
      name: 'amc_branded_search_rate_by_campaign',
      id: 'amc_branded_search_rate_by_campaign',
      pageNumber: 1,
      pageSize: 100,
      doAggregation: true,
      returnDocuments: false,
      conditions: {
        condition: 'must',
        termFilters: [
          {
            fieldName: 'periodStartDate',
            condition: 'should',
            values: [startDayId]
          },
          {
            fieldName: 'periodEndDate',
            condition: 'should',
            values: [endDayId]
          },
          {
            fieldName: 'retailerId',
            condition: 'should',
            values: [retailerId]
          }
        ],
        computeFilters: []
      },
      searchBy: 'parent',
      aggregations: [
        {
          aggregationFields: [
            {
              aggregateByFieldName: 'beaconClientId',
              function: 'sum',
              canBeExported: true
            },
            {
              aggregateByFieldName: 'impressions',
              function: 'sum',
              canBeExported: true
            },
            {
              aggregateByFieldName: 'numberOfBrandedSearches',
              function: 'sum',
              canBeExported: true
            }
          ],
          groupByFieldName: 'campaign.keyword'
        }
      ],
      searchType: 'advertising-amc-audiences-branded-search-rate-over-time-by-campaign',
      processDocuments: false
    }
  ];
};

export const convertBrandedSearchRateByCampaignDataToCsv = ({ data, dateRange }): string => {
  const headers = ['Campaign Name', `Branded Search Rate: ${dateRange}`].map((val) => `"${val}"`).join(',');

  const values = data.map((dataPoint) => {
    const campaignName = dataPoint[0];
    const dataValue = dataPoint[1] / 100;
    return [`${campaignName}`, `${dataValue}`].map((val) => `"${val}"`).join(',');
  });

  return `${headers}\n${values.join('\n')}`;
};
